import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import AddToCartButton from '~/components/molecules/addToCartButton/AddToCartButton';
import Rating from '~/components/molecules/rating/rating';
import { ProductResultAvailability } from '~/components/organisms/products/productSingleResult/ProductResultAvailability';
import { useProductContext } from '~/components/organisms/products/productSingleResult/productResultContext';
import { useSERPState } from '~/core/state/SERPStateContext';
import { useDynamicComponents } from '~/plugins/dynamicComponents/dynamicComponentsContext';
import { useDeliveryClassName } from '~/utils/components/deliveryClassName';

const ProductSingleResult = () => {
    const { result, style } = useProductContext();
    const { ProductResultHead, ProductResultImage, ProductColors, ProductResultPrice } = useDynamicComponents();
    const deliveryClassName = useDeliveryClassName();
    const state = useSERPState();

    const showAddToCartButton = state.config.showAddToCartButton;
    const showResultPrice =
        result.originalPrice !== undefined || result.price !== undefined || result.priceWithoutVat !== undefined;

    const showResultGift = !!result.gift;

    const showResultDelivery = !!result.delivery;

    const showResultData = showResultPrice || showResultGift || showResultDelivery;

    const showResultDiscount = result.discount !== undefined && result.discount !== 0;

    const showStockAvailability = result.stockAvailability !== undefined && result.stockAvailability !== null;

    const MAX_STOCK_TO_DISPLAY = 5;

    return (
        <>
            <ProductResultHead>
                <ProductResultImage />
            </ProductResultHead>
            <ProductColors />

            {showResultData ? (
                <div
                    className={classNames(style.serpProductData, {
                        [style.inRows]: state.resultLayout === 'rows',
                    })}
                >
                    {result.rating !== undefined ? <Rating value={parseFloat(result.rating)} /> : null}
                    <div>
                        {showResultDiscount ? (
                            <div className={style.serpProductDiscountWrapper} data-testid="product-result-discount">
                                <div role="paragraph" className={style.serpProductDiscount}>
                                    <FormattedMessage id="discount" defaultMessage="SLEVA" /> {result.discount}{' '}
                                    <FormattedMessage id="discount_unit" defaultMessage="%" />
                                </div>
                            </div>
                        ) : null}
                        {showResultPrice ? <ProductResultPrice /> : null}
                        {showResultGift ? (
                            <div role="paragraph" className={style.serpProductGift}>
                                {result.gift}
                            </div>
                        ) : null}
                        {showResultDelivery ? (
                            <div role="paragraph" className={style.serpProductStock} data-testid="product-result-stock">
                                <FormattedMessage id="delivery" defaultMessage="Dostupnost:" />{' '}
                                <span className={classNames(deliveryClassName)}>
                                    {result.delivery}
                                    {result.inStock && (
                                        <>
                                            {' '}
                                            ({result.inStock > MAX_STOCK_TO_DISPLAY && '>'}
                                            {Math.min(result.inStock, MAX_STOCK_TO_DISPLAY)}&nbsp;ks)
                                        </>
                                    )}
                                </span>
                            </div>
                        ) : null}
                        {showStockAvailability ? <ProductResultAvailability /> : null}
                    </div>
                    {showAddToCartButton ? (
                        <AddToCartButton>
                            <FormattedMessage id="add_to_cart" defaultMessage="Do košíku" />
                        </AddToCartButton>
                    ) : null}
                </div>
            ) : null}
        </>
    );
};

export default ProductSingleResult;
